/**
 * Website Preloader Logic
 * Monitors hero videos loading on first load and hides preloader overlay smoothly.
 */

document.addEventListener('DOMContentLoaded', function () {
    const preloader = document.getElementById('site-preloader');
    if (!preloader) return;

    document.body.classList.add('preloader-active');

    const progressBar = document.getElementById('preloaderProgress');
    const percentEl = document.getElementById('preloaderPercent');
    const statusEl = document.getElementById('preloaderStatus');

    let currentProgress = 0;
    let targetProgress = 10;
    let isFinished = false;

    // Smoothly interpolate progress animation
    const updateUI = () => {
        if (currentProgress < targetProgress) {
            currentProgress += Math.min(3, targetProgress - currentProgress);
            if (progressBar) progressBar.style.width = currentProgress + '%';
            if (percentEl) percentEl.textContent = Math.round(currentProgress) + '%';
        }

        if (!isFinished || currentProgress < 100) {
            requestAnimationFrame(updateUI);
        } else {
            finishPreloader();
        }
    };
    requestAnimationFrame(updateUI);

    // Hero Videos & Media detection
    const heroVideos = Array.from(document.querySelectorAll('.home-hero video, .home-hero iframe, .home-hero__slide.has-video video, .home-hero__slide.has-video iframe'));
    let loadedCount = 0;
    const totalMedia = heroVideos.length;

    const onMediaLoaded = () => {
        loadedCount++;
        if (totalMedia > 0) {
            const calculated = Math.round(20 + (loadedCount / totalMedia) * 75);
            targetProgress = Math.max(targetProgress, calculated);
        }
        if (loadedCount >= totalMedia) {
            completeLoading();
        }
    };

    if (totalMedia > 0) {
        if (statusEl) statusEl.textContent = 'Loading Videos...';

        heroVideos.forEach((media) => {
            if (media.tagName.toLowerCase() === 'video') {
                if (media.readyState >= 3) {
                    onMediaLoaded();
                } else {
                    const handleVideoReady = () => {
                        media.removeEventListener('canplay', handleVideoReady);
                        media.removeEventListener('loadeddata', handleVideoReady);
                        media.removeEventListener('playing', handleVideoReady);
                        onMediaLoaded();
                    };
                    media.addEventListener('canplay', handleVideoReady);
                    media.addEventListener('loadeddata', handleVideoReady);
                    media.addEventListener('playing', handleVideoReady);
                    media.addEventListener('error', onMediaLoaded); // gracefully handle error
                }
            } else if (media.tagName.toLowerCase() === 'iframe') {
                if (media.complete || media.readyState === 'complete') {
                    onMediaLoaded();
                } else {
                    media.addEventListener('load', onMediaLoaded);
                    media.addEventListener('error', onMediaLoaded);
                }
            } else {
                onMediaLoaded();
            }
        });
    } else {
        // No hero videos, complete faster
        targetProgress = 70;
    }

    // Window load event as secondary trigger
    window.addEventListener('load', function () {
        targetProgress = Math.max(targetProgress, 90);
        setTimeout(completeLoading, 300);
    });

    function completeLoading() {
        if (isFinished) return;
        targetProgress = 100;
        isFinished = true;
        if (statusEl) statusEl.textContent = 'Ready';
    }

    function finishPreloader() {
        setTimeout(function () {
            preloader.classList.add('is-loaded');
            document.body.classList.remove('preloader-active');

            setTimeout(function () {
                preloader.style.display = 'none';
                preloader.setAttribute('aria-hidden', 'true');
            }, 650);
        }, 200);
    }

    // Safety timeout: max 3 seconds delay to avoid blocking slow connections
    setTimeout(function () {
        if (!isFinished) {
            completeLoading();
        }
    }, 3000);
});
